import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FirebaseTSFirestore } from 'firebasets/firebasetsFirestore/firebaseTSFirestore';

@Component({
  selector: 'app-content-display',
  templateUrl: './content-display.component.html',
  styleUrls: ['./content-display.component.css']
})
export class ContentDisplayComponent implements OnInit {
  contentDisplayForm: FormGroup;
  firestore: FirebaseTSFirestore;

  constructor(private fb: FormBuilder) {
    this.firestore = new FirebaseTSFirestore();
  }

  ngOnInit(): void {
    this.contentDisplayForm = this.fb.group({
      postSorting: ['chronological'] // Valeur par défaut
    });

    this.loadContentDisplaySettings();
  }

  loadContentDisplaySettings() {
    this.firestore.getDocument({
      path: ["Users", /* USER_ID */],
      onComplete: result => {
        const data = result.data();
        this.contentDisplayForm.patchValue({
          postSorting: data?.postSorting || 'chronological'
        });
      },
      onFail: err => {
        console.error(err);
      }
    });
  }

  onSubmit() {
    if (this.contentDisplayForm.valid) {
      this.firestore.update({
        path: ["Users", /* USER_ID */],
        data: this.contentDisplayForm.value,
        onComplete: () => {
          console.log("Paramètres d'affichage des contenus mis à jour.");
        },
        onFail: err => {
          console.error(err);
        }
      });
    }
  }
}
